import { captureMessage } from '@sentry/vue'
import Vue from 'vue'
import type VueI18n from 'vue-i18n'
import type Vuetify from 'vuetify/lib'

import SimpleAudioPlayer from '@/common/components/SimpleAudioPlayer.vue'
import { pinia } from '@/common/stores'

const mountPlayers = <T extends Element>(
    contentElement: T | undefined,
    dark: boolean,
    i18n: VueI18n,
    vuetify: Vuetify
): void => {
    if (!contentElement) {
        captureMessage('No content element provided to mount audio players', {
            level: 'error'
        })

        return
    }

    contentElement.querySelectorAll('audio:not(.player-embedded)').forEach(element => {
        const audio = element as HTMLAudioElement
        const title = audio.dataset.title === undefined ? '' : audio.dataset.title
        const source = audio.querySelector('source')

        if (source !== null) {
            new Vue({
                render: h => h(SimpleAudioPlayer, {
                    props: {
                        dark,
                        source: source.src,
                        title
                    }
                }),
                i18n,
                pinia,
                vuetify
            }).$mount(audio)
        }
    })
}

export { mountPlayers }
